import {
  AppleLogo,
  CoinsIcon,
  DiscoverIcon,
  DiscoverIconActive,
  DuckbillLogo,
  GoogleLogo,
  HomeIcon,
  HomeIconActive,
  IconSquareMenu,
  OutlookLogo,
  TaskIcon,
  TaskIconActive,
} from '@frontend/web-icons';
import type { Icon, IconProps, icons } from '@tabler/icons-react';
import {
  IconActivity,
  IconAlarmOff,
  IconAlarmSnooze,
  IconAlertCircle,
  IconAlertCircleFilled,
  IconAlignLeft,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowDownLeft,
  IconArrowFork,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpRight,
  IconArrowsMove,
  IconArrowsUpDown,
  IconAwardFilled,
  IconBan,
  IconBarrierBlock,
  IconBeach,
  IconBell,
  IconBook,
  IconBookmark,
  IconBrandSafari,
  IconBulb,
  IconBulbOff,
  IconCake,
  IconCalendar,
  IconCalendarEvent,
  IconCancel,
  IconCar,
  IconCaretDown,
  IconCaretLeft,
  IconCaretRight,
  IconCaretUp,
  IconCash,
  IconCheck,
  IconCheckbox,
  IconChecklist,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleArrowUpRight,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleDotted,
  IconClipboardData,
  IconClock,
  IconCoin,
  IconCoins,
  IconCopy,
  IconCopyCheck,
  IconCornerDownLeft,
  IconCreditCard,
  IconCrown,
  IconDots,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileCertificate,
  IconFileDescription,
  IconFilePlus,
  IconFlag,
  IconFlagFilled,
  IconGift,
  IconGlobe,
  IconGps,
  IconGripHorizontal,
  IconHeartHandshake,
  IconHeartbeat,
  IconHistory,
  IconHome,
  IconHomeFilled,
  IconHourglassLow,
  IconInbox,
  IconInfoCircle,
  IconInfoCircleFilled,
  IconLayout2,
  IconLayout2Filled,
  IconLibraryPhoto,
  IconLink,
  IconList,
  IconListCheck,
  IconLock,
  IconLogout,
  IconMail,
  IconMailOpened,
  IconMapPin,
  IconMenu2,
  IconMessage,
  IconMessage2,
  IconMessageCircleUser,
  IconMessageDots,
  IconMicrophone,
  IconMicrophoneOff,
  IconMinus,
  IconMoodConfuzed,
  IconMoodHeart,
  IconMoodKid,
  IconMoon,
  IconMug,
  IconNote,
  IconNotification,
  IconPaperclip,
  IconPencil,
  IconPhone,
  IconPlaneTilt,
  IconPlayerPauseFilled,
  IconPlayerPlay,
  IconPlayerSkipForward,
  IconPlus,
  IconPointFilled,
  IconPointer,
  IconReceipt2,
  IconRefresh,
  IconRepeat,
  IconRotate,
  IconSalad,
  IconScissors,
  IconScript,
  IconSearch,
  IconSeeding,
  IconSend,
  IconSettings,
  IconSettingsFilled,
  IconShare2,
  IconShieldCheck,
  IconShieldLock,
  IconShoppingBag,
  IconShoppingBagX,
  IconShoppingCart,
  IconShoppingCartSearch,
  IconSparkles,
  IconSquareCheck,
  IconStack,
  IconStar,
  IconStarFilled,
  IconStethoscope,
  IconSun,
  IconSunrise,
  IconSunset2,
  IconTicket,
  IconTool,
  IconToolsKitchen3,
  IconTrash,
  IconTruck,
  IconUser,
  IconUserCircle,
  IconUserPlus,
  IconUserStar,
  IconUsers,
  IconWindmill,
  IconX,
} from '@tabler/icons-react';

import type { ForwardRefExoticComponent, RefAttributes } from 'react';

type AllIconName = keyof typeof icons;

type IconComponent = ForwardRefExoticComponent<IconProps & RefAttributes<Icon>>;

// https://tabler.io/icons
export const tablerIconsMap = {
  IconActivity,
  IconAlarmOff,
  IconAlarmSnooze,
  IconAlertCircle,
  IconAlertCircleFilled,
  IconAlignLeft,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowDownLeft,
  IconArrowFork,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpRight,
  IconArrowsMove,
  IconArrowsUpDown,
  IconAwardFilled,
  IconBan,
  IconBarrierBlock,
  IconBeach,
  IconBell,
  IconBook,
  IconBookmark,
  IconBrandSafari,
  IconBulb,
  IconBulbOff,
  IconCake,
  IconCalendar,
  IconCalendarEvent,
  IconCancel,
  IconCar,
  IconCaretDown,
  IconCaretLeft,
  IconCaretRight,
  IconCaretUp,
  IconCash,
  IconCheck,
  IconCheckbox,
  IconChecklist,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleArrowUpRight,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleDotted,
  IconClipboardData,
  IconClock,
  IconCoin,
  IconCoins,
  IconCopy,
  IconCopyCheck,
  IconCornerDownLeft,
  IconCreditCard,
  IconCrown,
  IconDots,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileCertificate,
  IconFileDescription,
  IconFilePlus,
  IconFlag,
  IconFlagFilled,
  IconGift,
  IconGlobe,
  IconGps,
  IconGripHorizontal,
  IconHeartHandshake,
  IconHeartbeat,
  IconHistory,
  IconHome,
  IconHomeFilled,
  IconHourglassLow,
  IconInbox,
  IconInfoCircle,
  IconInfoCircleFilled,
  IconLayout2,
  IconLayout2Filled,
  IconLibraryPhoto,
  IconLink,
  IconList,
  IconListCheck,
  IconLock,
  IconLogout,
  IconMail,
  IconMailOpened,
  IconMapPin,
  IconMenu2,
  IconMessage,
  IconMessage2,
  IconMessageCircleUser,
  IconMessageDots,
  IconMicrophone,
  IconMicrophoneOff,
  IconMinus,
  IconMoodConfuzed,
  IconMoodHeart,
  IconMoodKid,
  IconMoon,
  IconMug,
  IconNote,
  IconNotification,
  IconPaperclip,
  IconPencil,
  IconPhone,
  IconPlaneTilt,
  IconPlayerPauseFilled,
  IconPlayerPlay,
  IconPlayerSkipForward,
  IconPlus,
  IconPointFilled,
  IconPointer,
  IconReceipt2,
  IconRefresh,
  IconRepeat,
  IconRotate,
  IconSalad,
  IconScissors,
  IconScript,
  IconSearch,
  IconSeeding,
  IconSend,
  IconSettings,
  IconSettingsFilled,
  IconShare2,
  IconShieldCheck,
  IconShieldLock,
  IconShoppingBag,
  IconShoppingBagX,
  IconShoppingCart,
  IconShoppingCartSearch,
  IconSparkles,
  IconSquareCheck,
  IconStack,
  IconStar,
  IconStarFilled,
  IconStethoscope,
  IconSun,
  IconSunrise,
  IconSunset2,
  IconTicket,
  IconTool,
  IconToolsKitchen3,
  IconTrash,
  IconTruck,
  IconUser,
  IconUserCircle,
  IconUserPlus,
  IconUserStar,
  IconUsers,
  IconWindmill,
  IconX,
} satisfies Partial<Record<AllIconName, IconComponent>>;

export const customIconsMap = {
  AppleLogo,
  CoinsIcon,
  DiscoverIcon,
  DiscoverIconActive,
  DuckbillLogo,
  GoogleLogo,
  HomeIcon,
  HomeIconActive,
  IconSquareMenu,
  OutlookLogo,
  TaskIcon,
  TaskIconActive,
} as const;

export type CustomIconName = keyof typeof customIconsMap;

export type TablerIconName = keyof typeof tablerIconsMap;

export type IconName = CustomIconName | TablerIconName;
